import React from 'react';

export default function CustomerStatsGrid({ stats }) {
  return (
    <div className="mt-6 pt-6 border-t">
      <h3 className="font-bold mb-4">Statistics</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-muted/50 p-3 rounded-xl text-center">
          <p className="text-2xl font-black">{stats.total_bookings}</p>
          <p className="text-xs text-muted-foreground">Total Bookings</p>
        </div>
        <div className="bg-green-50 p-3 rounded-xl text-center">
          <p className="text-2xl font-black text-green-600">{stats.confirmed_bookings}</p>
          <p className="text-xs text-muted-foreground">Confirmed</p>
        </div>
        <div className="bg-red-50 p-3 rounded-xl text-center">
          <p className="text-2xl font-black text-red-600">{stats.cancelled_bookings}</p>
          <p className="text-xs text-muted-foreground">Cancelled</p>
        </div>
        <div className="bg-primary/10 p-3 rounded-xl text-center">
          <p className="text-2xl font-black text-primary">${stats.total_spent.toFixed(2)}</p>
          <p className="text-xs text-muted-foreground">Total Spent</p>
        </div>
      </div>
    </div>
  );
}
